import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { DlgEmployeeWorkingTimeComponent } from 'src/app/modules/employee/components/employee-working-time/dlg-employee-working-time/dlg-employee-working-time.component';
import { asShortDate } from 'src/app/shared/classes/utils/time.utils';
import { hAll } from 'src/app/shared/classes/utils/utils';
import { ExtLoopBackAuth } from 'src/app/shared/modules/ext-sdk/services/ext-sdk-auth.service';
import { UiService } from 'src/app/shared/modules/ui/services/ui.service';
import { oc } from 'ts-optchain';
import { ConfigService } from '../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { ABaseModelLoaderComponent } from '../../../../shared/modules/ui/components/abstract/a-base-model-loader.component';
import { Config, ConfigApi, DriverSchedule, DriverScheduleApi, Employee, EmployeeApi, EmployeeWorkingTime, EmployeeWorkingTimeApi, LoggerService, TripManifest, Vehicle, VehicleApi, } from '../../../../shared/sdk';
import { HelperService as ConsumerHelperService } from '../../../consumer/services/helper.service';
import { HelperService as EmployeeHelperService } from '../../../employee/services/helper.service';
import { HelperService } from '../../services/helper.service';
import { RouterHelperService } from '../../services/router-helper.service';
import { DlgOverwriteManifestConfirm } from './dlg-overwrite-manifest-confirm/dlg-overwrite-manifest-confirm.component';
import { DlgRoutesMapComponent } from './dlg-routes-map/dlg-routes-map.component';
import { GridHelperService } from 'src/app/shared/modules/ui/services/grid-helper.service';
export class RouterComponent extends ABaseModelLoaderComponent {
    constructor(http, snackBar, cd, logger, config, dss, ui, helper, tripRouter, consumerHelper, employeeHelper, dialog, sanitizer, gridHelper, auth) {
        super(logger, dss);
        this.http = http;
        this.snackBar = snackBar;
        this.cd = cd;
        this.logger = logger;
        this.config = config;
        this.dss = dss;
        this.ui = ui;
        this.helper = helper;
        this.tripRouter = tripRouter;
        this.consumerHelper = consumerHelper;
        this.employeeHelper = employeeHelper;
        this.dialog = dialog;
        this.sanitizer = sanitizer;
        this.gridHelper = gridHelper;
        this.auth = auth;
        this.orderOptions = [
            { key: 'least', value: 'Least Busy First' },
            { key: 'most', value: 'Most Busy First' },
        ];
        this.destinationsMap = {};
        this.selectedDate = new Date();
        this.vehicles = [];
        this.vehiclesAvailable = [];
        this.vehAmblsAvailable = [];
        this.manifestVehiclesMap = {};
        this.vehiclesMap = {};
        this.selectedVehicleIds = [];
        this.employees = [];
        this.employeesAvailable = [];
        this.driversAmblsAvailable = [];
        this.escortsAmblsAvailable = [];
        this.employeeMap = {};
        this.employeeWorkingTimeMap = {};
        this.selectedEmployeeIdsSet = new Set();
        this.keepManifestTrips = false;
        this.withPreferred = false;
        this.withAvoid = false;
        this.useCache = false;
        this.manifestGroups = [];
        this.manifestGroupsOrg = [];
        this.conflictTripsMap = {};
        this.dataSource = [];
        this.dataSourceOrder = 'least';
        this.showWorkTime = false;
        this.lockSelectedTrips = false;
        this.totals = {
            manifest: { totalVehicles: 0, combinedLoadedMinutes: 0, totalNumberOfTrips: 0 },
            proposed: { totalVehicles: 0, combinedLoadedMinutes: 0, totalNumberOfTrips: 0 },
        };
        this.errorStyle = 'background-color: #ffc1c1; color: #333; padding: 2px 3px; border-radius: 4px;margin-left: -3px;';
        this.breakStyle = 'background-color: #c1ffc1; color: #333; padding: 2px 3px; border-radius: 4px;margin-right: -3px;';
        this.isToday = (date) => moment(date).isSame(moment(), 'day');
        this.isTomorrow = (date) => moment(date).isSame(moment().add(1, 'day'), 'day');
        this.getCalendarBadgeClasses = (date) => ({
            'badge-small': true,
            red: this.isToday(date),
            orange: this.isTomorrow(date),
            green: !this.isToday(date) && !this.isTomorrow(date),
        });
        this.getCalendarText = (date) => {
            const todayOrTomorrow = (this.isToday(date) && 'Today') || (this.isTomorrow(date) && 'Tomorrow');
            if (todayOrTomorrow)
                return `${todayOrTomorrow} (${moment(date).format('ddd')})`;
            return moment(date).format('dddd');
        };
        this.grid_onDragStart = (e) => {
            this.tripRouter.dragStart(e, this.dataSource);
        };
        this.grid_onDragMove = (e) => {
            this.tripRouter.dragMove(e, this.cd);
        };
        this.grid_onDragChange = (e) => {
            this.tripRouter.dragChange(e, this.http, this.cd, this.dataSource, asShortDate(this.selectedDate));
        };
        this.grid_onAdd = (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.tripRouter.dragAdd(e, this.http, this.dataSource, asShortDate(this.selectedDate));
            this.totals.proposed = Object.assign({}, this.tripRouter.calculateTotals(this.dataSource.map(t => t.proposedGroup).filter(t => t)));
        });
        this.emplDisplayExpr = (e) => this.employeeHelper.displayExpr(e) + (this.tripRouter.isAmbulanceDriver(e) ? ' (EVOC)' : '');
        this.escDisplayExpr = (e) => this.employeeHelper.displayExpr(e) + (this.tripRouter.isAmbulanceEscort(e) ? ' (EMT)' : '');
        this.getSequenceClass = ({ dragPushed, dragPushedBefore }) => 'badge-small ' + ((dragPushed && 'orange') || (dragPushedBefore && 'orange light') || '');
        this.getConsumerFullName = c => this.consumerHelper.displayExpr(c.__consumer);
        this.toDate = (time) => (time ? moment(time, 'HH:mm:ss').toDate() : null);
        this.getConsumerSettings = ({ __consumer: c }) => {
            if (!c)
                return '';
            const settings = [];
            if (c.keepStretcher)
                settings.push('KS');
            if (c.onBoardingDuration)
                settings.push('PU+');
            if (c.offBoardingDuration)
                settings.push('DO+');
            return settings.join(', ');
        };
        this.distanceInMiles = (distance) => (distance && Math.round(distance * 0.000621371192)) || 0;
        this.getSchedulingConflicts = () => Object.keys(this.conflictTripsMap).length;
    }
    ngOnInit() {
        super.ngOnInit();
        void this.loadData();
    }
    get ModelClass() {
        return Employee;
    }
    calendar_onValueChanged(e) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.ui.showLoading();
            yield this.loadManifest();
            yield this.loadEmployeeWorkingTime();
            this.tripRouter.sortDataSource(this.dataSource, this.dataSourceOrder, this.employeeWorkingTimeMap);
            this.ui.hideLoading();
        });
    }
    getLoadBadgeClasses(group) {
        return {
            'badge-yellow': group.load.percent > 10 && group.load.percent <= 45,
            'badge-green': group.load.percent > 45,
        };
    }
    getHours(totalMinutes) {
        if (!totalMinutes)
            return '00:00';
        const hh = Math.floor(totalMinutes / 60);
        const mm = Math.abs(totalMinutes % 60);
        return `${hh.toString().padStart(2, '0')}:${mm.toString().padStart(2, '0')}`;
    }
    selectedVehiclesChangeHandler(e) {
        this.setVehiclesAvailable();
        const set = new Set(this.selectedVehicleIds);
        this.dataSource.forEach(d => {
            if (d.manifestGroup && d.manifestGroup.vehicle && !set.has(d.manifestGroup.vehicle.id)) {
                d.manifestGroup.vehicle = null;
                d.manifestGroup.employee = null;
            }
            if (d.proposedGroup && d.proposedGroup.vehicle && !set.has(d.proposedGroup.vehicle.id)) {
                d.proposedGroup.vehicle = null;
                d.proposedGroup.employee = null;
            }
        });
    }
    assignVehicleHandler(group, altGroup, value) {
        if (!this.selectedVehicleIds.includes(value)) {
            this.selectedVehicleIds.push(value);
        }
        group.vehicle = this.vehiclesMap[value];
        if (altGroup)
            altGroup.vehicle = this.vehiclesMap[value];
    }
    assignEmployeeHandler(group, altGroup, value) {
        this.selectedEmployeeIdsSet.add(value);
        group.employee = this.employeeMap[value];
        if (altGroup)
            altGroup.employee = this.employeeMap[value];
        this.setEmployeesAvailable();
    }
    assignEscortHandler(group, altGroup, value) {
        this.selectedEmployeeIdsSet.add(value);
        group.escort = this.employeeMap[value];
        if (altGroup)
            altGroup.escort = this.employeeMap[value];
        this.setEmployeesAvailable();
    }
    removeVehicleHandler(group, altGroup) {
        const idx = this.selectedVehicleIds.indexOf(group.vehicle.id);
        if (idx !== -1)
            this.selectedVehicleIds.splice(idx, 1);
        group.vehicle = null;
        if (altGroup)
            altGroup.vehicle = null;
    }
    removeEmployeeHandler(group, altGroup) {
        this.selectedEmployeeIdsSet.delete(group.employee.id);
        group.employee = null;
        if (altGroup)
            altGroup.employee = null;
        this.setEmployeesAvailable();
    }
    removeEscortHandler(group, altGroup) {
        this.selectedEmployeeIdsSet.delete(group.escort.id);
        group.escort = null;
        if (altGroup)
            altGroup.escort = null;
        this.setEmployeesAvailable();
    }
    shouldShowKeepManifestTrips() {
        return !this.manifestGroups.every(g => g.vehicle);
    }
    loadData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.ui.showLoading();
            this.destinationsMap = yield this.dss.getApi(Config).getDestinationsMap().toPromise();
            this.vehicles = (yield this.dss
                .getApi(Vehicle)
                .find({ where: { state: 'ACTIVE' }, order: 'internalId' })
                .toPromise());
            this.employees = (yield this.dss
                .getApi(Employee)
                .find(
            // TODO: remove hardcode
            { where: { employeePositionId: { inq: [39, 40, 273, 294, 295] } }, include: ['person'] }, hAll)
                .toPromise()).sort((a, b) => {
                const a1 = this.employeeHelper.displayExpr(a);
                const b1 = this.employeeHelper.displayExpr(b);
                return a1 < b1 ? -1 : a1 > b1 ? 1 : 0;
            });
            this.vehiclesMap = this.vehicles.reduce((p, v) => (Object.assign({}, p, { [v.id]: v })), {});
            this.employeeMap = this.employees.reduce((p, e) => (Object.assign({}, p, { [e.id]: e })), {});
            yield this.loadManifest();
            yield this.loadEmployeeWorkingTime();
            this.tripRouter.sortDataSource(this.dataSource, this.dataSourceOrder, this.employeeWorkingTimeMap);
            this.ui.hideLoading();
        });
    }
    loadManifest() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.manifest = yield this.helper.api.getCurrentManifest(asShortDate(this.selectedDate)).toPromise();
            const as = yield this.helper.buildArrayStoreAsync(this.manifest);
            const detailedTrips = as._array;
            this.manifestGroups = this.tripRouter.makeManifestGroups(detailedTrips);
            this.manifestGroupsOrg = JSON.parse(JSON.stringify(this.manifestGroups));
            this.manifestVehiclesMap = this.manifestGroups.reduce((p, { vehicle: v }) => (v ? Object.assign({}, p, { [v.id]: v }) : p), {});
            this.selectedVehicleIds = this.manifestGroups.map(g => g.vehicle && g.vehicle.id).filter(id => id);
            this.setVehiclesAvailable();
            this.selectedEmployeeIdsSet = new Set(this.manifestGroups.flatMap(g => [g.employee && g.employee.id, g.escort && g.escort.id]));
            this.setEmployeesAvailable();
            this.conflictTripsMap = {};
            this.dataSource = this.manifestGroups.map(g => ({ manifestGroup: g }));
            this.totals.manifest = this.tripRouter.calculateTotals(this.manifestGroups);
            this.totals.proposed = { totalVehicles: 0, combinedLoadedMinutes: 0, totalNumberOfTrips: 0 };
        });
    }
    loadEmployeeWorkingTime() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const date = asShortDate(this.selectedDate);
            const data = yield this.dss
                .getApi(EmployeeWorkingTime)
                .findAllByDate(date, hAll)
                .toPromise();
            this.employeeWorkingTimeMap = data.reduce((p, v) => (Object.assign({}, p, { [v.employeeId]: v })), {});
        });
    }
    setVehiclesAvailable() {
        const set = new Set(this.selectedVehicleIds);
        this.vehiclesAvailable = this.vehicles.filter(v => !set.has(v.id) && !this.tripRouter.isAmbulanceVehicle(v));
        this.vehAmblsAvailable = this.vehicles.filter(v => !set.has(v.id) && this.tripRouter.isAmbulanceVehicle(v));
    }
    setEmployeesAvailable() {
        const set = this.selectedEmployeeIdsSet;
        this.employeesAvailable = this.employees.filter(e => !set.has(e.id) && !this.tripRouter.isAmbulanceEscort(e));
        this.driversAmblsAvailable = this.employees.filter(e => !set.has(e.id) && this.tripRouter.isAmbulanceDriver(e));
        this.escortsAmblsAvailable = this.employees.filter(e => !set.has(e.id) && this.tripRouter.isAmbulanceEscort(e));
    }
    sortDataSourceHandler(e) {
        this.tripRouter.sortDataSource(this.dataSource, this.dataSourceOrder, this.employeeWorkingTimeMap);
    }
    proposeHandler() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.ui.showLoading();
            try {
                const selectedVehicleIdsSet = new Set(this.selectedVehicleIds);
                const keepManifestTrips = this.shouldShowKeepManifestTrips() && this.keepManifestTrips;
                const [tripsPool, vehicles, canceledTrips] = this.tripRouter.makeTripsPool(oc(this).manifest.data([]), this.manifestGroups, keepManifestTrips, selectedVehicleIdsSet);
                const proposedGroups = yield this.tripRouter.proposeGroups(this.http, tripsPool, this.selectedVehicleIds.length, this.withPreferred, this.withAvoid, !this.useCache, vehicles, asShortDate(this.selectedDate), this.dss);
                proposedGroups.sort((a, b) => b.workingMinutes - a.workingMinutes);
                let dataSrc = this.tripRouter.sortDataSource([...this.manifestGroups].map((manifestGroup, i) => ({ manifestGroup })), 'least', this.employeeWorkingTimeMap);
                dataSrc = this.tripRouter.assignProposedGroups(dataSrc, proposedGroups, selectedVehicleIdsSet, this.selectedVehicleIds, this.manifestVehiclesMap, this.vehiclesMap, canceledTrips);
                this.totals.proposed = Object.assign({}, this.tripRouter.calculateTotals(dataSrc.map(t => t.proposedGroup).filter(t => t)));
                this.tripRouter.sortDataSource(dataSrc, this.dataSourceOrder, this.employeeWorkingTimeMap);
                this.dataSource = dataSrc;
            }
            catch (error) {
                console.error(error);
                this.snackBar.open(error.message, 'Close', {
                    duration: 3000,
                });
            }
            this.ui.hideLoading();
        });
    }
    calculateTravelHandler() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.ui.showLoading();
            yield this.tripRouter.calculateTravel(this.http, this.totals, asShortDate(this.selectedDate), this.dataSource, this.destinationsMap, this.dss, this.employeeWorkingTimeMap);
            this.ui.hideLoading();
        });
    }
    lockFirstTripsOrClearAllHandler() {
        if (this.lockSelectedTrips)
            this.clearSelectedTrips();
        else
            this.lockFirstTrips();
    }
    lockFirstTrips() {
        this.dataSource.forEach(({ manifestGroup }) => {
            if (manifestGroup && manifestGroup.trips && manifestGroup.vehicle) {
                const t = manifestGroup.trips[0];
                if (t)
                    t.lock = true;
            }
        });
        this.lockSelectedTrips = true;
    }
    clearSelectedTrips() {
        this.dataSource.forEach(({ manifestGroup }) => {
            if (manifestGroup && manifestGroup.trips) {
                manifestGroup.trips.forEach(t => (t.lock = false));
            }
        });
        this.lockSelectedTrips = false;
    }
    lockChangeHandler() {
        this.lockSelectedTrips = this.dataSource.some(({ manifestGroup }) => manifestGroup && manifestGroup.trips.some(t => t.lock));
    }
    openRoutesMap(group) {
        if (!group || !group.trips)
            return;
        const title = `Veh #${group.vehicle.internalId} ${this.employeeHelper.displayExpr(group.employee)}`;
        const { routes, markers } = this.tripRouter.getRoutesAndMarkers(group.trips, this.destinationsMap);
        this.dialog.open(DlgRoutesMapComponent, {
            hasBackdrop: true,
            data: {
                title: `Routes Map for ${title}`,
                markers,
                routes,
            },
        });
    }
    openWorkingHours() {
        this.dialog.open(DlgEmployeeWorkingTimeComponent, {
            hasBackdrop: true,
            data: { selectedDate: asShortDate(this.selectedDate) },
        });
    }
    getFullAddress(cellInfo) {
        return this.tripRouter.getAddr(cellInfo.value, cellInfo.data.__consumer, this.destinationsMap);
    }
    getAddressCell(cellInfo) {
        const val = cellInfo.value;
        const addr = this.getFullAddress(cellInfo);
        const fn = this.getConsumerFullName(cellInfo.row.data);
        const noAddr = `No address provided for ${val === 'RESIDENCE' ? fn : val}`;
        const title = addr ? `Address: ${addr}` : noAddr;
        const style = !addr ? this.errorStyle : '';
        const html = `<span style="${style}" title="${title}">${val}</span>`;
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    getPickupCell(cellInfo, trips) {
        const puTime = moment(cellInfo.value, 'HH:mm:ss').format('hh:mm A');
        let html = `<span>${puTime}</span>`;
        try {
            if (cellInfo.rowIndex > 0) {
                const prev = trips[cellInfo.rowIndex - 1];
                const curr = trips[cellInfo.rowIndex];
                if (prev.dot > curr.t && !prev.x && !curr.x) {
                    this.conflictTripsMap[curr.id] = true;
                    const doTime = moment(prev.dot, 'HH:mm:ss').format('hh:mm A');
                    const title = `Previous Dropoff Time (${doTime}) is after Current Pickup Time (${puTime})`;
                    html = `<span style="${this.errorStyle}" title="${title}">${puTime}</span>`;
                }
            }
        }
        catch (error) { }
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    getFreeTimeCell(nextFreeMinutes) {
        if (!nextFreeMinutes)
            return '';
        const style = nextFreeMinutes >= 60 ? this.breakStyle : nextFreeMinutes < 0 ? this.errorStyle : '';
        return this.sanitizer.bypassSecurityTrustHtml(`<span style="${style}">${this.getHours(nextFreeMinutes)}h</span>`);
    }
    grid_onInitialized(e) {
        this.gridHelper.handle(e.component, {
        // notifyErrors: true,
        });
    }
    grid_onCellPrepared(e) {
        if (e && e.data && e.data[this.helper.getRecFieldMap.cancelled]) {
            e.cellElement.style.textDecoration = 'line-through';
        }
    }
    // async exportGroups(groupName: string) {
    //   const workbook = new Workbook();
    //   for (const [index, dataGrid] of this.dataGrids.toArray().entries()) {
    //     const worksheet = workbook.addWorksheet(`Grid ${index + 1}`);
    //     await exportDataGrid({
    //       component: dataGrid.instance,
    //       worksheet: worksheet,
    //       autoFilterEnabled: true
    //     });
    //   }
    //   // const buffer = await workbook.xlsx.writeBuffer();
    //   // saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrids.xlsx');
    // }
    overwriteAllManifestHandler() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.dialog
                .open(DlgOverwriteManifestConfirm, {
                hasBackdrop: true,
                data: { selectedDate: moment(this.selectedDate).format('dddd M/D/YYYY') },
            })
                .afterClosed()
                .subscribe((result) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                const today = this.isToday(this.selectedDate);
                if (result && (!today || confirm('Are you sure you want to overwrite the manifest for today?'))) {
                    this.ui.showLoading();
                    yield this.overwriteAllManifest();
                    if (result.overwriteSchedules)
                        yield this.overwriteSchedules();
                    yield this.tripRouter.logGmapOverwriteAllManifest(this.http, asShortDate(this.selectedDate));
                    yield this.saveEmployeeWorkingTime();
                    yield this.loadManifest();
                    yield this.loadEmployeeWorkingTime();
                    this.tripRouter.sortDataSource(this.dataSource, this.dataSourceOrder, this.employeeWorkingTimeMap);
                    this.ui.hideLoading();
                }
            }));
        });
    }
    overwriteAllManifest() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const proposedTripsPool = this.dataSource.flatMap(({ proposedGroup }) => oc(proposedGroup)
                .trips([])
                .map((t, i) => (Object.assign({}, t, { e: (proposedGroup.employee && proposedGroup.employee.id) || -1, esc: (proposedGroup.escort && proposedGroup.escort.id) || null, v: (proposedGroup.vehicle && proposedGroup.vehicle.id) || null, tr: i + 1 }))));
            yield this.helper.api.updateManifest(this.manifest.id, proposedTripsPool).toPromise();
        });
    }
    saveEmployeeWorkingTime() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const date = asShortDate(this.selectedDate);
            const data = this.dataSource.flatMap(({ proposedGroup: pg }) => {
                if (!pg || !pg.load || !pg.trips)
                    return [];
                const { workingMinutes } = pg;
                const arr = [];
                if (pg.employee && pg.employee.id > 0)
                    arr.push({ status: 'DRIVER', employeeId: pg.employee.id, workingMinutes });
                if (pg.escort && pg.escort.id > 0)
                    arr.push({ status: 'ESCORT', employeeId: pg.escort.id, workingMinutes });
                return arr;
            });
            yield this.dss.getApi(EmployeeWorkingTime).saveManyByDate(date, data, hAll).toPromise();
        });
    }
    overwriteSchedules() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const date = asShortDate(this.selectedDate);
            yield this.dss.getApi(DriverSchedule).dropAll(date, true).toPromise();
            const docs = this.dataSource.flatMap(({ proposedGroup: pg }) => {
                if (!pg || !pg.load || !pg.trips)
                    return [];
                const { startTime, finishTime } = pg;
                const [startTimeCalculatedAt, finishTimeCalculatedAt] = [new Date(), new Date()];
                const facilityId = this.auth.getCurrentTenant();
                const { startLocationAddress, finishLocationAddress, startLocationCoords, finishLocationCoords } = pg;
                const { startLocationCalculated, finishLocationCalculated, startTravelDuration, finishTravelDuration } = pg;
                const { startTripTime, finishTripTime, startTripLocationAddress, finishTripLocationAddress } = pg;
                const { startTripLocation, startTripConsumerName, finishTripLocation, finishTripConsumerName } = pg;
                const data = Object.assign({ mode: 'AUTO', day: date, date: `${date}T16:00:00.000Z` }, { facilityId, startFacilityId: facilityId, finishFacilityId: facilityId }, { startTime, finishTime, startTimeCalculatedAt, finishTimeCalculatedAt }, { startInstructions: '', finishInstructions: '' }, { startLocationAddress, finishLocationAddress, startLocationCoords, finishLocationCoords }, { startLocationCalculated, finishLocationCalculated, startTravelDuration, finishTravelDuration }, { startTripTime, finishTripTime, startTripLocationAddress, finishTripLocationAddress }, { startTripLocation, startTripConsumerName, finishTripLocation, finishTripConsumerName });
                const arr = [];
                if (pg.employee && pg.employee.id > 0)
                    arr.push(Object.assign({ status: 'DRIVER', driverId: pg.employee.id }, data));
                if (pg.escort && pg.escort.id > 0)
                    arr.push(Object.assign({ status: 'ESCORT', driverId: pg.escort.id }, data));
                return arr;
            });
            try {
                yield this.dss.getApi(DriverSchedule).createMany(docs, hAll).toPromise();
            }
            catch (error) {
                console.log('Ignore it if you have manual schedules', error);
            }
        });
    }
}
